var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureUnplag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3906 15.9883C15.6556 15.9883 10.9229 20.2852 10.2285 25.832H4.51562V28.6445H10.2286C10.9229 34.1913 15.6555 38.4883 21.3906 38.4883H22.7969C23.5759 38.4883 24.2031 37.8611 24.2031 37.082V34.2695H28.4219V31.457H24.2031V23.0195H28.4219V20.207H24.2031V17.3945C24.2031 16.6155 23.5759 15.9883 22.7969 15.9883H21.3906ZM41.0781 15.9883C40.2991 15.9883 39.6719 16.6155 39.6719 17.3945V20.207H42.4844V23.0195H39.6719V31.457H42.4844V34.2695H39.6719V37.082C39.6719 37.8611 40.2991 38.4883 41.0781 38.4883H49.5156V15.9883H41.0781Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78906 50.9688L50.7278 3.02999",
    stroke: "#8F4300",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureUnplag);
export default __webpack_public_path__ + "static/media/Feature_Unplag.cd0e52501392ab829494388039961aef.svg";
export { ForwardRef as ReactComponent };